import { Reveal } from "@/components/Reveal";
import { SectionParticles } from "@/components/SectionParticles";
import { AccordionList } from "@/components/Accordion";
import { CAMPAIGN } from "@/lib/campaign";

const MODULES = [
  {
    title: "VERIFY THE BENEFIT",
    body: "Learn which questions help verify VA eligibility, entitlement, prior use, and documentation. This session is not an official VA event and is not a substitute for VA/lender review.",
  },
  {
    title: "MODEL THE BUYING-POWER INPUTS",
    body: "Organize the income, debt, credit, assets, reserves, occupancy, and property questions that influence an individualized review—without quoting a universal purchase price or payment.",
  },
  {
    title: "UNDERSTAND CASH CATEGORIES",
    body: "Separate down payment from deposits, inspections, appraisal, closing costs, prepaid items, reserves, the funding-fee question, and possible credits. Zero down does not mean zero cash needed.",
  },
  {
    title: "PREPARE THE PURCHASE & OFFER PATH",
    body: "Learn the stages from readiness through application, home search, offer, appraisal, underwriting, and closing, plus questions for coordinating a VA-financed offer. Seller acceptance is never promised.",
  },
  {
    title: "LEAVE WITH THREE NEXT ACTIONS",
    body: "Complete the Benefit-to-Keys Workbook and decide whether the next move is eligibility research, preparation, a strategy session, an application, or a home search after financing guardrails are established.",
  },
];

/* SECTION 7 — CURRICULUM */
export const Curriculum = () => (
  <section className="relative overflow-hidden px-5 md:px-10 lg:px-16 py-28 md:py-36" data-testid="curriculum-section">
    <div
      aria-hidden="true"
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: "url(/assets/bg-home-3.jpg)" }}
    />
    <div
      aria-hidden="true"
      className="absolute inset-0"
      style={{ background: "linear-gradient(180deg, rgba(0,0,99,0.96), rgba(0,0,99,0.9), rgba(0,0,99,0.96))" }}
    />
    <SectionParticles variant="keys" />
    <div className="relative z-10 max-w-4xl mx-auto text-left">
      <p className="font-mono text-[11px] tracking-[0.3em] text-[var(--muted)] mb-10">
        [004] — THE WORKSHOP
      </p>
      <Reveal>
        <h2 className="font-display font-semibold text-3xl md:text-5xl text-white mb-4">
          A PRACTICAL LOOK INSIDE THE SESSION
        </h2>
        <p className="font-mono text-[11px] tracking-[0.14em] text-[var(--muted)] mb-12">
          5 MODULES · {CAMPAIGN.webinarDuration}
        </p>
      </Reveal>
      <Reveal>
        <AccordionList items={MODULES} testPrefix="curriculum-accordion" />
      </Reveal>
    </div>
  </section>
);
